import { t } from 'i18next';

export const atLeastOneUppercase = /[A-Z]/g;
export const atLeastOneLowercase = /[a-z]/g;
export const atLeastOneNumeric = /[0-9]/g;
export const atLeastOneSpecialChar = /[~@#_^*%/.+:;=,!?<>()[\]{}'"\\\-&|$]/g;
export const eightCharsOrMore = /.{8,}/g;

export interface PasswordTracker {
  uppercase: boolean;
  lowercase: boolean;
  number: boolean;
  specialChar: boolean;
  eightCharsOrGreater: boolean;
}

export const getPasswordTracker = (password: string): PasswordTracker => {
  return {
    uppercase: !!password.match(atLeastOneUppercase),
    lowercase: !!password.match(atLeastOneLowercase),
    number: !!password.match(atLeastOneNumeric),
    specialChar: !!password.match(atLeastOneSpecialChar),
    eightCharsOrGreater: !!password.match(eightCharsOrMore)
  };
};

export const getPasswordStrength = (tracker: PasswordTracker): number => {
  return Object.values(tracker).filter((value) => value).length;
};

export const buildPasswordStrengthMessage = (tracker: PasswordTracker): string => {
  const strength = getPasswordStrength(tracker);
  if (strength >= 5) return '';

  const parts: string[] = [];
  if (!tracker.eightCharsOrGreater) parts.push(t('8 caracteres alfanuméricos'));
  if (!tracker.uppercase) parts.push(t('una mayúscula'));
  if (!tracker.lowercase) parts.push(t('una minúscula'));
  if (!tracker.specialChar) parts.push(t('un caracter especial'));
  if (!tracker.number) parts.push(t('un número'));

  const last = parts.pop();
  if (!last) return '';

  return t('Debe contener al menos ') + parts.join(', ') + (parts.length > 0 ? t(' y ') : '') + last;
};
